class ArticlesHttp {

  static getArticles = async () => {
    const response = await fetch("https://ebullion.zendesk.com/api/v2/help_center/en-us/articles.json", {
      method: "GET", // *Type of request GET, POST, PUT, DELETE
      mode: "cors", // Type of mode of the request
      cache: "no-cache", // options like default, no-cache, reload, force-cache
      credentials: "same-origin", // options like include, *same-origin, omit
      headers: {
        "Content-Type": "application/json" // request content type
      },
    });
    return await response.json()
  }

  static filterArticles = async (data:any) => {
    const response = await fetch("https://ebullion.zendesk.com/api/v2/help_center/en-us/articles.json?label_names="+ data, {
      method: "GET", // *Type of request GET, POST, PUT, DELETE
      mode: "cors", // Type of mode of the request
      cache: "no-cache", // options like default, no-cache, reload, force-cache
      credentials: "same-origin", // options like include, *same-origin, omit
      headers: {
        "Content-Type": "application/json" // request content type
      },
    });
    return await response.json()
  }
}

export default ArticlesHttp;
